// extracted by mini-css-extract-plugin
export default {"root":"NoChangeIcon_root__PfCR8","left-arrow":"NoChangeIcon_left-arrow__QF8+N","right-arrow":"NoChangeIcon_right-arrow__B91f7"};